<template>
  <div>
    <Head title="Vytvořit kalkulaci" />
    <h1 class="mb-8 text-3xl font-bold">
      <!-- <Link class="text-indigo-400 hover:text-indigo-600" href="/components">Kalkulace</Link> -->
      <!-- <span class="text-indigo-400 font-medium">/</span> Kalkulace -->
      Kalkulace RD
    </h1>
    <div v-if="form.set">
      <div v-if="form.set.note" class="mb-4 p-4 text-orange-800 bg-orange-300 border border-orange-800 rounded">
        <strong>POZNÁMKA:</strong><br />
        <div class="mt-2" v-html="form.set.note" />
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form ref="formref" @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <!-- <div class="mt-4 w-full">
            <h2 class="mb-4 text-2xl font-bold">Zákazník</h2>
          </div> -->

          <div class="mt-4 w-full">
            <h2 class="mb-4 text-2xl font-bold">FVE</h2>
            <div v-if="sets.length !== 0" class="flex gap-2 items-center mt-4 w-full">
              <select-input v-model="form.set_id" class="pb-8 pr-6 w-full lg:w-1/3" label="* Vyberte set" @change="setChanged">
                <option :value="null" disabled selected>Vyberte set</option>
                <option v-for="set in sets" :key="set.id" :value="set.id">{{ set.name }}</option>
              </select-input>
              <div v-if="form.set_id" class="flex mb-4 p-4 w-full h-full bg-indigo-100 lg:w-1/3">
                <div class="font-bold">Výkon FVE</div>
                <div class="ml-auto">{{ fvePower }} kWp</div>
              </div>
              <div v-if="form.set_id" class="flex mb-4 p-4 w-full h-full bg-indigo-100 lg:w-1/3">
                <div class="font-bold">Kapacita FVE</div>
                <div class="ml-auto">{{ fveCapacity }} kWh</div>
              </div>
            </div>

            <div v-if="form.components.length !== 0" class="mb-4 w-full overflow-x-auto">
              <table class="w-full whitespace-nowrap" :class="form.subject">
                <thead>
                  <tr class="text-left font-bold">
                    <th class="pb-4 pt-6">Komponenty</th>
                    <th class="pb-4 pt-6 px-6">Počet (ks)</th>
                    <th class="pb-4 pt-6 px-6 text-right">Cena/ks</th>
                    <th class="pb-4 pt-6 px-6 text-right">Celkem</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="component in form.components" :key="component.id">
                    <tr v-if="component.type != 'custom'" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="component.id == 46 || component.id == 45 ? 'not-household' : ''">
                      <td class="py-2 text-sm border-t" :style="component.color ? { color: component.color } : ''">{{ component.name }}</td>
                      <td class="px-6 text-sm border-t">
                        <text-input v-if="component.editable" v-model="component.quantity" type="number" :min="component.min" :max="component.max" required step="any" class="form-input-sm w-full" @change="component.type == 'panel' || component.type == 'battery' || component.type == 'inverter' ? preCalculateRules() : ''" />
                        <span v-else>{{ component.quantity }}</span>
                      </td>
                      <td class="px-6 text-right text-sm border-t">{{ $filters.currency(component.unit_price) }}</td>
                      <td class="px-6 text-right text-sm border-t">{{ $filters.currency(component.unit_price * component.quantity) }}</td>
                    </tr>
                    <!-- Custom components-->
                    <tr v-else>
                      <td class="flex items-center py-2 text-sm border-t">
                        <button class="mr-2 px-2 py-1 text-red-500 text-sm bg-red-50 border border-red-500 rounded" @click="removeCustomComponent(component)">-</button>
                        <text-input class="form-input-sm w-full" required v-model="component.name" type="text" />
                        <SelectInput v-model="component.group" class="form-input-sm pl-2">
                          <option v-for="(componentGroup, index) in componentGroups" :key="index" :value="index">{{ componentGroup }}</option>
                        </SelectInput>
                      </td>
                      <td class="px-6 text-sm border-t">
                        <text-input v-model="component.quantity" class="form-input-sm w-full" type="number" />
                      </td>
                      <td class="px-6 text-right text-sm border-t"><text-input class="form-input-sm w-full" v-model="component.unit_price" type="number" /></td>
                      <td class="px-6 text-right text-sm border-t">{{ $filters.currency(component.unit_price * component.quantity) }}</td>
                    </tr>
                    <!-- Custom components end-->
                  </template>
                  <tr v-if="form.discount_type == 'battery'" class="text-green-600">
                    <td class="py-2 text-sm border-t">Baterie zdarma</td>
                    <td class="px-6 text-sm border-t"><span>1</span></td>
                    <td class="px-6 text-right text-sm border-t">0 Kč</td>
                    <td class="px-6 text-right text-sm border-t">0 Kč</td>
                  </tr>
                </tbody>
              </table>
              <div class="mt-4">
                <button @click="addCustomComponent" class="btn-outline-indigo">+ Přidat vlastní komponentu</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.set_id" class="-mr-6 mb-4 p-8">
          <div class="flex flex-wrap w-full">
            <select-input v-model="form.subject" class="pb-8 pr-6 w-full lg:w-1/3" label="Typ klienta" @change="changeSubject()">
              <option value="household" selected>Rodinný dům - fyzická os.</option>
              <option value="household-legal" selected>Rodinný dům - právnická os.</option>
              <option value="company" selected>Firma / Obec</option>
              <option value="svj" selected>SVJ nad 50% obytné plochy</option>
              <option value="svj-noresident" selected>SVJ do 50% obytné plochy</option>
            </select-input>
            <select-input v-if="form.subject != 'household'" v-model="form.vatPayer" class="pb-8 pr-6 w-full lg:w-1/4" label="Plátcovství DPH">
              <option :value="false" selected>Neplátce DPH</option>
              <option :value="true">Plátce DPH</option>
            </select-input>
            <text-input v-if="form.subject == 'svj' || form.subject == 'svj-noresident'" v-model="form.apartments" :error="form.errors.apartments" required type="number" min="1" step="any" class="pb-4 pr-6 w-full lg:w-1/4" label="Počet byt. jednotek" />
            <label v-if="form.subject == 'company'" class="flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.nrb" class="mr-2" type="checkbox" />NRB</label>
            <label v-if="form.subject == 'company'" class="flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.isCompanySubsidy" class="mr-2" type="checkbox" />Dotace</label>
          </div>
          <div v-if="form.set && form.set.subsidy_type == 'february-2025' && (form.subject == 'household' || form.subject == 'household-legal')" class="flex flex-wrap gap-2 mb-4 p-4 w-full bg-green-100">
            <label class="flex items-center pr-6 w-full lg:w-auto"><input v-model="form.static_subsidy_sharing" class="mr-2" type="checkbox" />realizace systému zapojeného do sdílení vyrobené energie</label>
            <label class="flex items-center pr-6 w-full lg:w-auto"><input v-model="form.static_subsidy_insulation" class="mr-2" type="checkbox" />kombinační bonus s oblastí podpory A - zateplení budovy</label>
            <label class="flex items-center pr-6 w-full lg:w-auto"><input v-model="form.static_subsidy_odpb" class="mr-2" type="checkbox" />kombinační bonus v programu ODPB</label>
          </div>
          <!-- Dotace firmy-->
          <div v-if="form.subject == 'company' && form.isCompanySubsidy" class="flex flex-wrap mb-4 p-4 w-full bg-green-100">
            <text-input v-if="form.subject == 'company' && form.isCompanySubsidy && form.nrb" v-model="form.companyPrelimSubsidyPercent" :error="form.errors.companyPrelimSubsidyPercent" required type="number" min="0" max="100" step="any" class="pb-4 pr-6 w-full lg:w-1/4" label="Předběžná dotace v %" />
            <text-input v-if="form.subject == 'company' && form.isCompanySubsidy && !form.nrb" v-model="form.companyPrelimSubsidy" :error="form.errors.companyPrelimSubsidy" required type="number" min="0" step="any" class="pb-4 pr-6 w-full lg:w-1/4" label="Předběžná dotace v Kč" />
            <text-input v-if="form.subject == 'company' && form.isCompanySubsidy && !form.nrb" v-model="form.companyEnergyAssesment" :error="form.errors.companyEnergyAssesment" required type="number" min="0" step="any" class="pb-4 pr-6 w-full lg:w-1/4" label="Energetický posudek v Kč" />
            <text-input v-if="form.subject == 'company' && form.isCompanySubsidy && !form.nrb" v-model="form.companyProcessingSubsidy" :error="form.errors.companyProcessingSubsidy" required type="number" min="0" step="any" class="pb-4 pr-6 w-full lg:w-1/4" label="Podání žádosti o dotaci v Kč" />
          </div>

          <div class="flex flex-wrap w-full">
            <select-input ref="discountType" v-model="form.discount_type" class="pb-8 pr-6 w-full lg:w-auto" label="Typ slevy" @change="changeDiscountType()">
              <option value="percent" selected>Procenta</option>
              <option value="amount">Částka</option>
              <option v-if="form.set_id != 13" :disabled="!canBatteryFree()" value="battery">+ 1 baterie zdarma</option>
            </select-input>
            <text-input v-if="form.discount_type == 'percent'" v-model="form.discount" :error="form.errors.discount" required type="number" :max="form.nrb ? 5 : 5" step="any" class="pb-4 pr-6 w-full lg:w-1/4" label="Sleva v %" />
            <text-input v-if="form.discount_type == 'amount'" ref="discountAmount" v-model="form.discount" :error="form.errors.discount" required type="number" min="0" step="any" class="pb-4 pr-6 w-full lg:w-1/4" label="Sleva v Kč" />
            <!-- <label class="flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.flat_roof" class="mr-2" type="checkbox" />Nutnost plošiny</label> -->
            <label class="flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.favored_region" class="mr-2" type="checkbox" />Zvýhodněný kraj</label>
            <label class="hidden items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.eternit" class="mr-2" type="checkbox" />Eternit bez azbestu</label>
          </div>
          <div>
            <label class="flex hidden items-center mt-2 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.isWaterHeating" class="mr-2" type="checkbox" />Ohřev vody</label>
            <text-input v-if="form.isWaterHeating" v-model="form.waterHeatingPrice" :error="form.errors.waterHeatingPrice" required type="number" min="0" step="any" class="pb-4 pr-6 w-full lg:w-1/4" label="Cena ohřevu vody v Kč bez DPH" />
            <div v-if="form.isWaterHeating" class="mb-5 mt-2 p-5 bg-orange-200 rounded"><strong>Nutno ke smlouvě dodat druhou část Přílohy č.1</strong> (tabulka komponent - ohřev vody)</div>
          </div>

          <div class="flex items-center">
            <loading-button :loading="calculating" class="btn-indigo" :class="form.needOffer ? 'opacity-40' : ''" :disabled="form.needOffer" @click="calculate(false)">Přepočítat</loading-button>
            <span v-if="form.needOffer" class="ml-2 text-orange-600 text-sm"><i>Pro přepočet odškrtněte "generovat nabídku"</i></span>
          </div>
          <div v-if="calculated">
            <div class="mt-6 w-full">
              <h2 class="mb-6 text-2xl font-bold">Kalkulace</h2>
            </div>
            <div class="flex">
              <div class="mb-4 ml-auto mr-8 w-full">
                <div class="flex p-4 font-bold bg-gray-100">
                  <div class="">Celkem bez DPH</div>
                  <div class="ml-auto">{{ $filters.currency(price) }}</div>
                </div>
                <div v-if="salesmanDiscount != 0" class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="">Sleva individuální (bez DPH)</div>
                  <div class="ml-auto text-right">
                    <span class="text-red-500">- {{ $filters.currency(salesmanDiscount) }}</span> <br />
                    <span class="text-xs">{{ $filters.currency(price - salesmanDiscount) }}</span>
                  </div>
                </div>
                <div v-if="wallboxDiscount != 0" class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="">Sleva na fotovoltaiku (bez DPH)</div>
                  <div class="ml-auto text-right">
                    <span class="text-red-500">- {{ $filters.currency(wallboxDiscount) }}</span> <br />
                    <span class="text-xs">{{ $filters.currency(price - salesmanDiscount - wallboxDiscount) }}</span>
                  </div>
                </div>
                <div v-if="discountedPrice != price" class="flex p-4 font-bold bg-gray-100">
                  <div class="">Celkem vč. slev bez DPH</div>
                  <div class="ml-auto">{{ $filters.currency(discountedPrice) }}</div>
                </div>

                <div class="flex mt-4 p-4 font-bold bg-gray-100">
                  <div class="">Celkem s DPH</div>
                  <div class="ml-auto">{{ $filters.currency(priceWithTax) }}</div>
                </div>
                <div class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="">DPH</div>
                  <div class="ml-auto">{{ $filters.currency(tax) }}</div>
                </div>

                <div v-if="mainSubsidy != 0" class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="">Dotace fotovoltaika</div>
                  <div class="ml-auto">{{ $filters.currency(mainSubsidy) }}</div>
                </div>
                <div v-if="wallBoxSubsidy != 0" class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="">Dotace ekomobilita</div>
                  <div class="ml-auto">{{ $filters.currency(wallBoxSubsidy) }}</div>
                </div>
                <div v-if="waterHeatingSubsidy != 0" class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="">Dotace ohřev vody</div>
                  <div class="ml-auto">{{ $filters.currency(waterHeatingSubsidy) }}</div>
                </div>
                <div v-if="insulationSubsidy != 0" class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="">Dotace zateplení</div>
                  <div class="ml-auto">{{ $filters.currency(insulationSubsidy) }}</div>
                </div>
                <template v-if="staticSubsidy">
                  <template v-for="(subsidyValue, subsidyKey) in staticSubsidy" :key="subsidyKey">
                    <div v-if="subsidyValue > 0" class="flex p-4 py-2 text-sm bg-gray-100">
                      <div class="">{{ subsidyKey == 'photovoltaic' ? 'Dotace fotovoltaika' : subsidyKey == 'sharing' ? 'Dotace sdílení vyrobené energie' : subsidyKey == 'odpb' ? 'Dotace ODPB' : 'Dotace zateplení' }}</div>
                      <div class="ml-auto">{{ $filters.currency(subsidyValue) }}</div>
                    </div>
                  </template>
                </template>
                <template v-if="insulationSubsidy != 0 && Object.keys(insulationSubsidyParts).length">
                  <div v-for="(value, key) in insulationSubsidyParts" :key="key" class="flex p-4 pl-6 py-1 text-xs bg-gray-200">
                    <div class="">{{ key }}</div>
                    <div class="ml-auto">{{ $filters.currency(value) }}</div>
                  </div>
                </template>
                <div v-if="subsidy != 0" class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="font-bold">Dotace celkem</div>
                  <div class="ml-auto">{{ $filters.currency(subsidy) }}</div>
                </div>
                <div v-if="subsidy != 0" class="flex mt-4 p-4 font-bold bg-green-200">
                  <div>Celkem s DPH a dotací</div>
                  <div class="ml-auto">{{ $filters.currency(totalPrice) }}</div>
                </div>

                <div v-if="companySubsidy" class="flex mt-4 p-4 font-bold bg-green-200">
                  <div class="">Předběžná výše dotace bez DPH</div>
                  <div class="ml-auto">{{ $filters.currency(companySubsidy.companyPrelimSubsidy) }}</div>
                </div>
                <div v-if="companySubsidy && companySubsidy.companyAdministrativeSubsidy != 0" class="flex p-4 py-2 text-sm bg-green-100">
                  <div class=""><span v-if="nrb">3 % z ceny</span><span v-else>5 % z výše dotace</span> - vyřízení administrace FVE (bez DPH)</div>
                  <div class="ml-auto">{{ $filters.currency(companySubsidy.companyAdministrativeSubsidy) }}</div>
                </div>
                <div v-if="companySubsidy && companySubsidy.companyEnergyAssesment != 0" class="flex p-4 py-2 text-sm bg-green-100">
                  <div class="">Vyřízení a vypracování energetického posudku (bez DPH)</div>
                  <div class="ml-auto">{{ $filters.currency(companySubsidy.companyEnergyAssesment) }}</div>
                </div>
                <div v-if="companySubsidy && companySubsidy.companyProcessingSubsidy != 0" class="flex p-4 py-2 text-sm bg-green-100">
                  <div class="">Podání a vyřízení žádosti o dotace (bez DPH)</div>
                  <div class="ml-auto">{{ $filters.currency(companySubsidy.companyProcessingSubsidy) }}</div>
                </div>
                <div v-if="companySubsidy" class="flex p-4 font-bold bg-green-100">
                  <div class="">Předpokládaná cena FVE po odečtení dotace a s ní spojenými náklady (bez DPH)</div>
                  <div class="ml-auto">{{ $filters.currency(totalPrice) }}</div>
                </div>
              </div>
            </div>
            <text-input v-model="form.case_code" :error="form.errors.case_code ? form.errors.case_code[0] : form.errors.case_code" class="pb-6 pr-6 w-full lg:w-1/3" label="Číslo obchodního případu" />
            <label v-if="form.set.model != 'insulation'" class="inline-flex items-center pb-4 pr-6 w-full lg:w-auto"><input v-model="form.needOffer" class="mr-2" type="checkbox" />Generovat nabídku?</label>
            <div class="mr-8">
              <div v-if="form.needOffer" class="p-4 w-full bg-orange-100">
                <h3 class="text-lg font-bold">Nastavení pro nabídku</h3>
                <select-input v-model="form.preoffer" class="mt-3 pb-6 pr-6 w-full lg:w-1/2" label="Listy před nabídkou">
                  <option :value="true" selected>Ano</option>
                  <option :value="false">Ne</option>
                </select-input>
                <div class="flex flex-wrap">
                  <text-input v-model="form.offer_salutation" :error="form.errors.offer_salutation" required class="pb-6 pr-6 w-full lg:w-1/2" label="Oslovení" />
                  <file-input v-model="form.offer_photo" :error="form.errors.offer_photo" class="pb-6 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Fotografie" />
                </div>
                <div class="flex flex-wrap">
                  <text-input v-model="form.offer_address" :error="form.errors.offer_address" class="pb-6 pr-6 w-full lg:w-2/3" required label="Adresa zákazníka" />
                  <select-input v-model="form.offer_region_exposure" class="pb-6 pr-6 w-full lg:w-1/3" required label="Kraj zákazníka">
                    <option :value="null" disabled selected>Vyberte kraj</option>
                    <option v-for="region in regions" :key="region.index" :value="region.index">{{ region.value }}</option>
                  </select-input>
                </div>
                <h3 class="text-base font-bold">Obchodní zástupce</h3>
                <div class="flex flex-wrap">
                  <text-input v-model="form.offer_contact" :error="form.errors.offer_contact" required class="mt-3 pb-6 pr-6 w-full lg:w-1/2" label="Jméno a příjmení OZ" />
                  <text-input v-model="form.offer_phone" :error="form.errors.offer_phone" required class="mt-3 pb-6 pr-6 w-full lg:w-1/2" label="Telefon" />
                </div>
                <h3 class="text-base font-bold">Rozmístění panelů</h3>
                <span class="text-sm"><i>Součet musí odpovídat celkovému počtu solárních panelů</i></span>
                <div class="flex flex-wrap">
                  <text-input v-model="form.offer_panel_east" :error="form.errors.offer_panel_east" type="number" required class="mt-3 pb-6 pr-6 w-full lg:w-1/4" label="Východ" />
                  <text-input v-model="form.offer_panel_west" :error="form.errors.offer_panel_west" type="number" required class="mt-3 pb-6 pr-6 w-full lg:w-1/4" label="Západ" />
                  <text-input v-model="form.offer_panel_south" :error="form.errors.offer_panel_south" type="number" required class="mt-3 pb-6 pr-6 w-full lg:w-1/4" label="Jih" />
                  <text-input v-model="form.offer_panel_north" :error="form.errors.offer_panel_north" type="number" required class="mt-3 pb-6 pr-6 w-full lg:w-1/4" label="Sever" />
                </div>
              </div>
            </div>
            <div v-if="owner">
              <label class="flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.priceBreakdown" class="mr-2" type="checkbox" />Cenový rozpad (kalkulace)</label>
            </div>
            <div v-if="form.needOffer && (form.subject == 'company' || form.subject == 'svj' || form.subject == 'svj-noresident')">
              <label class="flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.noPriceInGroup" class="mr-2" type="checkbox" />Skupiny bez cen (nabídka)</label>
            </div>
          </div>
        </div>

        <div v-if="calculated" class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <label class="flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="attachmentSeven" class="mr-2" :disabled="form.needOffer" type="checkbox" />odložená p.</label>
          <label v-if="!attachmentSeven" class="flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="withoutSubsidy" class="mr-2" type="checkbox" />bez dotace</label>
          <!-- <label v-if="!attachmentSeven" class="flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="withoutPrice" class="mr-2" type="checkbox" />bez cen</label> -->
          <text-input v-if="attachmentSeven" v-model="attachmentSevenAmount" :error="form.errors.attachmentSevenAmount" max="200000" min="25000" class="pb-6 pr-6 w-full lg:w-1/5" label="Výše zálohy" />
          <text-input v-model="signedDate" :error="form.errors.signedDate" class="pb-6 pr-6 w-full lg:w-1/4" label="Datum podpisu" />
          <text-input v-model="signedIn" :error="form.errors.signedIn" class="pb-6 pr-6 w-full lg:w-1/4" label="Místo podpisu" />
          <loading-button :loading="calculating" class="btn-indigo" @click.prevent="calculate(true)">Generovat PDF</loading-button>
        </div>
        <div class="flex hidden items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit" @click.prevent>Odeslat</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
// import TextAreaInput from '@/Shared/TextAreaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon'
import axios from 'axios'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    FileInput,
    Icon,
    // TextAreaInput,
  },
  layout: Layout,
  props: {
    sets: Array,
    components: Array,
    componentGroups: Object,
    set: Object,
    todayDate: String,
    owner: Boolean,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        //fve
        set_id: null,
        set: null,
        components: this.components,
        discount: 0,
        discount_type: 'percent',
        favored_region: false,
        flat_roof: false,
        eternit: false,
        nrb: false,
        priceBreakdown: false,
        noPriceInGroup: false,
        complicated: false,
        subject: 'household',
        vatPayer: false,
        needOffer: false,
        offer_salutation: 'Vážený zákazníku,',
        offer_photo: null,
        offer_address: null,
        offer_region_exposure: null,
        offer_contact: null,
        offer_phone: null,
        offer_panel_east: 0,
        offer_panel_west: 0,
        offer_panel_south: 0,
        offer_panel_north: 0,
        preoffer: true,
        case_code: null,
        isWaterHeating: false,
        waterHeatingPrice: null,
        //Svj
        apartments: 1,
        //Company subsudy
        isCompanySubsidy: false,
        companyPrelimSubsidy: 0,
        companyEnergyAssesment: 0,
        companyProcessingSubsidy: 0,
        companyPrelimSubsidyPercent: 0, //pouze pro nrb
        //static subsidy
        staticSubsidy: [],
        static_subsidy_sharing: false,
        static_subsidy_insulation: false,
        static_subsidy_odpb: false,
      }),
      initialUrl: this.$page.url,
      regions: [
        { index: 998, value: 'Hlavní město Praha' },
        { index: 998, value: 'Středočeský kraj' },
        { index: 1029, value: 'Jihočeský kraj' },
        { index: 1004, value: 'Plzeňský kraj' },
        { index: 987, value: 'Karlovarský kraj' },
        { index: 980, value: 'Ústecký kraj' },
        { index: 996, value: 'Liberecký kraj' },
        { index: 1013, value: 'Královéhradecký kraj' },
        { index: 1008, value: 'Pardubický kraj' },
        { index: 1026, value: 'Kraj Vysočina' },
        { index: 1049, value: 'Jihomoravský kraj' },
        { index: 1018, value: 'Olomoucký kraj' },
        { index: 1044, value: 'Zlínský kraj' },
        { index: 1001, value: 'Moravskoslezský kraj' },
      ],

      calculated: false,
      calculating: false,
      //prices
      price: 0,
      discountedPrice: 0,
      salesmanDiscount: 0,
      wallboxDiscount: 0,
      tax: 0,
      priceWithTax: 0,
      subsidy: 0,
      totalPrice: 0,
      fvePower: 0,
      fveCapacity: 0,
      signedIn: 'Praha',
      signedDate: null,
      withoutPrice: false,
      withoutSubsidy: false,
      attachmentSeven: false,
      attachmentSevenAmount: 25000,
      projectDefaultPrice: 0,
    }
  },
  methods: {
    store() {
      //nothing
    },
    setChanged() {
      this.$nextTick(() => {
        this.$inertia.get(
          '/calculations/create',
          {
            set_id: this.form.set_id,
          },
          {
            preserveState: true,
            preserveScroll: true,
            replace: false,
            only: ['components', 'set'],
            onSuccess: () => {
              this.form.components = this.components
              this.form.set = this.set
              this.preCalculateRules()
              this.calculate(false)
              //odebrání parametru set_id z url
              this.$inertia.get(this.initialUrl, {}, { replace: true, preserveScroll: true, preserveState: true })
            },
          },
          {},
        )
      })
    },
    addCustomComponent() {
      this.form.components.push({ name: '', type: 'custom', quantity: 1, unit_price: 0, warranty: '', description: '', group: 'components' })
    },
    removeCustomComponent(component) {
      this.form.components.splice(this.form.components.indexOf(component), 1)
    },
    componentsPrice() {
      let price = 0
      this.form.components.forEach((component) => {
        price += component.unit_price * component.quantity
      })
      return price
    },
    componentsPriceWithoutProject() {
      let price = 0
      this.form.components.forEach((component) => {
        if (component.type != 'project') price += component.unit_price * component.quantity
      })
      return price
    },
    calculate(needPdf = false) {
      //check if amount discount is not higher than 10% price
      let price = this.componentsPrice()
      let maxAmountPrice = this.owner ? price * 0.5 : price * 0.05
      if (this.form.discount_type == 'amount' && this.form.discount > maxAmountPrice) {
        //alert('Sleva nemůže být vyšší než 15% (' + price * 0.10 + ') z ceny komponentů.')
        this.$refs.discountAmount.$el.querySelector('input').setAttribute('max', maxAmountPrice)
        this.calculating = false
      }

      //validate form
      if (!this.$refs.formref.checkValidity()) {
        this.$refs.formref.reportValidity()
        return false
      }

      //validate signedIn
      if (needPdf && this.signedIn.length == 0) {
        alert('Místo podpisu musí být vyplněno.')
        return false
      }

      //Pokud je set panel_power > 10, minimální vkon fve je 10 kwp
      if (this.form.set.panel_power > 10) {
        if (this.fvePower < 10) {
          alert('Minimální vkon pro tento typ panelů je 10 kWh.')
          return false
        }
      }

      //Pokud není vyplněna alespoň jedna komponenta, která má group_required true, zobraz alert
      if (this.form.components.some((component) => component.group_required)) {
        if (!this.form.components.some((component) => component.group_required && component.quantity > 0)) {
          let componentNames = this.form.components
            .filter((component) => component.group_required)
            .map((component) => component.name)
            .join(', ')

          alert('Pozor, musíte vyplnit alespoň jednu komponentu z následujících: ' + componentNames)
          return false
        }
      }

      this.calculating = true

      //need send file
      this.$nextTick(() => {
        // Create a new FormData object
        let formData = new FormData()

        let payload = JSON.stringify({
          set_id: this.form.set_id,
          case_code: this.form.case_code,
          components: this.form.components,
          discount: this.form.discount,
          discount_type: this.form.discount_type,
          favored_region: this.form.favored_region,
          flat_roof: this.form.flat_roof,
          eternit: this.form.eternit,
          nrb: this.form.nrb,
          priceBreakdown: this.form.priceBreakdown,
          noPriceInGroup: this.form.noPriceInGroup,
          complicated: this.form.complicated,
          needPdf: needPdf,
          signedIn: this.signedIn,
          signedDate: this.signedDate,
          subject: this.form.subject,
          vatPayer: this.form.vatPayer,
          withoutPrice: this.withoutPrice,
          withoutSubsidy: this.withoutSubsidy,
          apartments: this.form.apartments,
          attachmentSeven: this.attachmentSeven,
          attachmentSevenAmount: parseInt(this.attachmentSevenAmount),
          needOffer: this.form.needOffer,
          isWaterHeating: this.form.isWaterHeating,
          waterHeatingPrice: this.form.waterHeatingPrice,
          offer_salutation: this.form.offer_salutation,
          offer_address: this.form.offer_address,
          offer_region_exposure: this.form.offer_region_exposure,
          offer_contact: this.form.offer_contact,
          offer_phone: this.form.offer_phone,
          offer_panel_east: this.form.offer_panel_east,
          offer_panel_west: this.form.offer_panel_west,
          offer_panel_south: this.form.offer_panel_south,
          offer_panel_north: this.form.offer_panel_north,
          preoffer: this.form.preoffer,
          isCompanySubsidy: this.form.isCompanySubsidy,
          companyPrelimSubsidy: this.form.companyPrelimSubsidy,
          companyEnergyAssesment: this.form.companyEnergyAssesment,
          companyProcessingSubsidy: this.form.companyProcessingSubsidy,
          companyPrelimSubsidyPercent: this.form.companyPrelimSubsidyPercent,
          static_subsidy_sharing: this.form.static_subsidy_sharing,
          static_subsidy_insulation: this.form.static_subsidy_insulation,
          static_subsidy_odpb: this.form.static_subsidy_odpb,
        })
        formData.append('payload', payload)

        // Append the photo if it's a file object
        if (this.form.offer_photo instanceof File) {
          formData.append('offer_photo', this.form.offer_photo)
        }
        axios
          .post('/calculations/calculate', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            //console.log(response.data)
            this.price = response.data.price
            this.tax = response.data.tax
            this.discountedPrice = response.data.discountedPrice
            this.salesmanDiscount = response.data.salesmanDiscount
            this.wallboxDiscount = response.data.wallboxDiscount
            this.priceWithTax = response.data.priceWithTax
            this.subsidy = response.data.subsidy
            this.mainSubsidy = response.data.mainSubsidy
            this.wallBoxSubsidy = response.data.wallBoxSubsidy
            this.waterHeatingSubsidy = response.data.waterHeatingSubsidy
            this.insulationSubsidy = response.data.insulationSubsidy
            this.insulationSubsidyParts = response.data.insulationSubsidyParts
            this.totalPrice = response.data.totalPrice
            this.companySubsidy = response.data.companySubsidy
            this.nrb = response.data.nrb
            this.staticSubsidy = response.data.staticSubsidy
            // this.fvePower = response.data.fvePower
            this.calculated = true
            if (response.data.pdf) {
              this.downloadFile(response.data.pdf)
              //window.open(response.data.pdf, '_blank')
            }
            if (response.data.pdf2) {
              this.downloadFile(response.data.pdf2)
              //window.open(response.data.pdf, '_blank')
            }
            if (response.data.pdfOffer) {
              this.downloadFile(response.data.pdfOffer)
              //window.open(response.data.pdf, '_blank')
            }
          })
          .catch((error) => {
            this.form.errors = error.response.data.errors
            if (this.form.errors && this.form.errors['case_code']) {
              this.form.errors['case_code'][0] = 'Číslo OP je povinné.'
            }
          })
          .finally(() => {
            this.calculating = false
          })
      })
    }, //end calculate
    //get fve power from components panels by pow_cap
    preCalculateRules() {
      let fvePower = 0
      let fveCapacity = 0
      let panelsCount = 0
      let batteryCount = 0
      let inverterCount = 0
      this.form.components.forEach((component) => {
        if (component.type == 'panel') {
          fvePower = fvePower + component.quantity * component.power_cap
          panelsCount = panelsCount + parseInt(component.quantity)
        }
        if (component.type == 'battery') {
          fveCapacity = fveCapacity + component.quantity * component.power_cap
          batteryCount = batteryCount + parseInt(component.quantity)
        }
      })
      this.form.components.forEach((component) => {
        if (component.type == 'inverter') {
          //retype to int
          inverterCount = inverterCount + parseInt(component.quantity)
        }
      })

      //if household, quantity for componentid 46 and 45 is 0
      if (this.form.subject == 'household' || this.form.subject == 'household-legal') {
        this.form.components.forEach((component) => {
          if (component.id == 46 || component.id == 45) {
            component.quantity = 0
          }
        })
      }

      //if household, vatPayer is false
      if (this.form.subject == 'household') {
        this.form.vatPayer = false
      }

      if (!this.canBatteryFree() && this.form.discount_type == 'battery') {
        this.form.discount_type = 'percent'
      }

      //add 10 kWh to battery capacity if battery discount is selected + battery count
      if (this.form.discount_type == 'battery') {
        fveCapacity = fveCapacity + 10
        batteryCount = batteryCount + 1
      }

      //custom project price for company
      // this.$nextTick(() => {
      //   this.companyProjectPrice()
      // })

      this.fvePower = fvePower.toFixed(2)
      this.fveCapacity = fveCapacity.toFixed(2)

      if (this.form.set.model != 'profi') {
        this.fillConstruction()
        this.fillInstalation()
        //this.fillShipping()
        this.fillCables()
        this.fillPhotovoltaicSwitchboard(inverterCount)
        //this.fillConnectors(panelsCount)
        this.fillOptimizers(panelsCount)

        this.fillBatterySwitchboard(batteryCount)
        this.fillBatteryDisconnector(batteryCount)
      }

      return fvePower
    },
    fillConstruction() {
      this.form.components.forEach((component) => {
        if (component.type == 'construction') {
          component.quantity = this.fvePower
        }
      })
    },
    fillInstalation() {
      this.form.components.forEach((component) => {
        if (component.type == 'instalation') {
          if (this.fvePower > 10) {
            component.quantity = (this.fvePower / 10).toFixed(2)
          } else {
            component.quantity = 1
          }
        }
      })
    },
    fillShipping() {
      this.form.components.forEach((component) => {
        if (component.type == 'shipping') {
          if (this.fvePower > 10) {
            component.quantity = (1 + (this.fvePower - 10) / 2 / 10).toFixed(4)
          } else {
            component.quantity = 1
          }
        }
      })
    },
    fillCables() {
      this.form.components.forEach((component) => {
        if (component.type == 'cables') {
          if (this.fvePower > 10) {
            component.quantity = Math.floor(this.fvePower / 10) * 200
          } else {
            component.quantity = 200
          }
        }
      })
    },

    fillPhotovoltaicSwitchboard(inverterCount = 0) {
      //sum all inverter count
      this.form.components.forEach((component) => {
        if (component.type == 'photovoltaic_switchboard') {
          component.quantity = inverterCount
        }
      })
    },
    //
    // fillConnectors(panelsCount = 0) {
    //   this.form.components.forEach((component) => {
    //     if (component.type == 'connectors') {
    //       component.quantity = panelsCount
    //       //1 connector for 2 panels
    //       if (component.quantity % 2 == 0) {
    //         component.quantity = component.quantity / 2
    //       } else {
    //         component.quantity = (component.quantity + 1) / 2
    //       }
    //     }
    //   })
    // },
    fillBatterySwitchboard(batteryCount = 0) {
      this.form.components.forEach((component) => {
        if (component.type == 'battery_switchboard') {
          //every started 3 batteries 1 switchboard
          if (batteryCount > 2) {
            if (batteryCount % 3 == 0) {
              component.quantity = batteryCount / 3
            } else {
              component.quantity = Math.floor(batteryCount / 3) + 1
            }
          } else {
            component.quantity = 0
          }
        }
      })
    },
    fillBatteryDisconnector(batteryCount = 0) {
      this.form.components.forEach((component) => {
        if (component.type == 'battery_disconnector') {
          if (batteryCount <= 2) {
            component.quantity = 1
          } else {
            component.quantity = 0
          }
        }
      })
    },
    //Když form.set.panel_power je větší než 10, nastav počet optimizerů na počet panelů
    fillOptimizers(panelsCount = 0) {
      this.form.components.forEach((component) => {
        if (component.type == 'optimizer') {
          if (this.form.set.panel_power > 10) {
            component.quantity = panelsCount
          }
        }
      })
    },
    //minimální počet panelů je tolik, aby byl vkon alespoň 10 kwp
    fillPanels() {
      this.form.components.forEach((component) => {
        if (component.type == 'panel') {
          if (this.form.set.panel_power > 10) {
            component.quantity = 19
          }
        }
      })
    },

    downloadFile(file) {
      let element = document.createElement('a')
      element.setAttribute('href', file.url)
      element.setAttribute('download', file.name)
      document.body.appendChild(element)
      element.click()
    },

    canBatteryFree() {
      if (this.form.components.length > 0) {
        let battery = this.form.components.find((component) => component.type == 'battery')
        if (battery) {
          if (battery.quantity > 0) {
            return true
          }
        }
      }
      return false
    },

    companyProjectPrice() {
      let project = this.form.components.find((component) => component.type == 'project')

      if (this.form.subject == 'company') {
        if (this.projectDefaultPrice == 0) {
          this.projectDefaultPrice = project.unit_price
        }

        let componentsPrice = this.componentsPriceWithoutProject()
        project.unit_price = componentsPrice * 0.11111111111111
      } else {
        //return back old price
        if (this.projectDefaultPrice != 0) project.unit_price = this.projectDefaultPrice
      }
    },

    changeDiscountType() {
      this.form.discount = 0
      this.preCalculateRules()
    },

    changeSubject() {
      //if subject is not company, set nrb to false
      if (this.form.subject != 'company') {
        this.form.nrb = false
        this.form.isCompanySubsidy = false
      }

      this.preCalculateRules()
    },
  },
}
</script>

<style scoped>
.household .not-household,
.household-legal .not-household {
  display: none;
}
.not-household {
  background-color: rgb(255, 250, 240);
}
</style>
